import React from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { BsFacebook, BsFillChatRightTextFill, BsInstagram, BsLinkedin } from "react-icons/bs";
import { presentationTranslate } from "../../../../i18n/translatedMessages";
import { FormattedMessage } from "react-intl";

const PresentationFiles = ({
  urlPdf,
  presentationData,
  handleChange,
  aboutMeCurrentChart,
  showAboutMeCurrentChar,
}) => {
  return (
    <>
      <div
        style={{ maxWidth: "400px" }}
        className="row d-flex justify-content-center container-presentation"
      >
        <div className="text-center my-3">
          <strong className="titulo-redes">{presentationTranslate.aboutYou}</strong>
        </div>
        <div className="">
          <Form>
            <Form.Group className="d-flex align-items-center align-content-center  mb-3">
              <Form.Label className="mb-0 me-2">
                <BsFillChatRightTextFill className="icons-rrss" size={30} />
              </Form.Label>
              <FormattedMessage id="writePresentationPH">
                {(msg) => (
                  <Form.Control
                    style={{ border: "solid 1px red" }}
                    as="textarea"
                    rows={2}
                    placeholder={msg}
                    maxLength={200}
                    name={"about_me"}
                    value={presentationData ? presentationData.about_me : ""}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
            {showAboutMeCurrentChar && (
              <Form.Text className="text-muted">
                <>
                  Le quedan{" "}
                  {aboutMeCurrentChart === 1
                    ? `${aboutMeCurrentChart} caracter `
                    : `${aboutMeCurrentChart} caracteres `}
                  disponibles
                </>
              </Form.Text>
            )}
            <div className="text-center my-3">
              <strong className="titulo-redes">{presentationTranslate.socialMedia}</strong>
            </div>
            <Form.Group className="d-flex align-items-center align-content-center  mb-3">
              <Form.Label className="mb-0 me-2">
                {" "}
                <BsInstagram className="icons-rrss" size={30} />{" "}
              </Form.Label>
              <FormattedMessage id="instagramLink">
                {(msg) => (
                  <Form.Control
                    name={"instagram"}
                    type="text"
                    placeholder={msg}
                    value={presentationData ? presentationData.instagram : ""}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
            <Form.Group className="d-flex align-items-center align-content-center  mb-3">
              <Form.Label className="mb-0 me-2">
                <BsLinkedin className="icons-rrss" size={30} />
              </Form.Label>
              <FormattedMessage id="linkedinLink">
                {(msg) => (
                  <Form.Control
                    name={"linkedin"}
                    type="text"
                    placeholder={msg}
                    value={presentationData ? presentationData.linkedin : ""}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
            <Form.Group className="d-flex align-items-center align-content-center  mb-3">
              <Form.Label className="mb-0 me-2">
                <BsFacebook className="icons-rrss" size={30} />
              </Form.Label>
              <FormattedMessage id="facebookLink">
                {(msg) => (
                  <Form.Control
                    name={"facebook"}
                    type="text"
                    placeholder={msg}
                    value={presentationData ? presentationData.facebook : ""}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Form>
        </div>
      </div>
    </>
  );
};

export default PresentationFiles;
